import onlyUnique from "utils/onlyUnique";

export default function getMergedPropertyCode({
  propertyCode,
  propertyCodes = [],
}) {
  return [...propertyCodes, propertyCode].filter(Boolean).filter(onlyUnique);
}
